import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import { RecoilRoot } from 'recoil';
import AlertTemplate from 'react-alert-template-basic';
import App from './App';
import { unregister } from './registerServiceWorker';

//Browser Cache Busting
unregister();

const rootElement = document.getElementById('root');

const alertOptions = {
	timeout: 3000,
	offset: '30px',
	position: positions.MIDDLE,
	transition: transitions.SCALE,
};

ReactDOM.render(
	<RecoilRoot>
		<Router>
			<AlertProvider template={AlertTemplate} {...alertOptions}>
				<App />
			</AlertProvider>
		</Router>
	</RecoilRoot>,
	rootElement
);
